import React from 'react';

export const LeftFriendsLine = () => {
    return (
        <svg width="178" height="90" viewBox="0 0 178 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.17" d="M15 15V15C15 48.1371 41.8629 75 75 75H163" stroke="url(#paint0_linear_10_215)"
                  stroke-width="30" stroke-linecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_10_215" x1="11.3062" y1="8.5" x2="170.219" y2="27.9081"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#7CA8FF" stop-opacity="0.9"/>
                    <stop offset="1" stop-color="#7CA8FF" stop-opacity="0.3"/>
                </linearGradient>
            </defs>
        </svg>
    )
}